import {
	DATA_LOADING,
	DATA_SAVING_FAILED,
	DATA_SAVING_SUCCESSED,
} from "../actions/types";
const initialState = {
	data: {},
	isLoading: false,
	saved: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case DATA_LOADING:
			return {
				...state,
				isLoading: true,
				saved: false,
			};
		case DATA_SAVING_SUCCESSED:
			return {
				...state,
				data: action.payload,
				isLoading: false,
				saved: true,
			};
		case DATA_SAVING_FAILED:
			return {
				...state,
				isLoading: false,
				saved: false,
			};
		default:
			return state;
	}
}
